/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';

import SlideShow from './SlideShow';
import { useAssetImages } from '../../../hooks';

const appendDistinctMedia = (items, newItem, prepend) => {
    if (!newItem){
        return items;
    }
    const toAppend = [];
    let found = false;
    for (let j = 0; j < items.length; j++) {
        if (items[j].media_id === newItem.media_id) {
            found = true;
            break;
        }
    }
    if (!found) {
        toAppend.push(newItem);
    }
    if (prepend) {
        return toAppend.concat(items);
    }
    return items.concat(toAppend);
}

export default function SlideShowWithFetch({
    assetId,
    campsiteId,
    tourId,
    timedEntryTourId,
    ...rest
}) {
    const { previewImage, heroImage, galleryImages, status } = useAssetImages({ assetId, campsiteId, tourId, timedEntryTourId });

    let galleryItems = [...galleryImages]
    if (heroImage && heroImage.media_id){
        galleryItems = appendDistinctMedia(galleryItems, heroImage);
    }

    // sort gallery by position and upload date
    galleryItems.sort((a, b) => {
        if (a.position < b.position) return -1;
        if (b.position < a.position) return 1;
        const keyA = Date.parse(a.created_date);
        const keyB = Date.parse(b.created_date);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
    });

    if (previewImage && previewImage.media_id) {
        galleryItems = appendDistinctMedia(galleryItems, previewImage, true);
    }

    return (
        <SlideShow
            images={galleryItems}
            status={status}
            {...rest} />
    );
}

SlideShowWithFetch.propTypes = {
    /** The id of the campground/permit/ticket facility/gateway/POI that the
     * api will use to fetch the images.
     * Do not use the images prop if using this prop. */
    assetId: PropTypes.string,

    /** The id of the campsite that the api will use to fetch the images
     * Do not use the images if using this prop.
    */
    campsiteId: PropTypes.string,

    /** The tour id the api will use to fetch the images
     * Do not use the images if using this prop.
    */
    tourId: PropTypes.string,

    /** The tour id the api will use to fetch the images
     * Do not use the images if using this prop.
     */
    timedEntryTourId: PropTypes.string
};
